
import { useEffect, useState } from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import { Row, Col } from "reactstrap"
import { COLORS } from "../constants"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { GameCard, CustomButton, BackButton, ShareModal } from "../components"
import child_request from "../assets/images/child_request.svg"
import gold_rosette from "../assets/images/Gold.svg"
import bronze_rosette from "../assets/images/Bronze.svg"
import grey_rosette from "../assets/images/Grey.svg"
import share from "../assets/images/share.svg"
import printer from "../assets/images/printer.svg";
import Certificate from "../pdf/Certificate"
import { BlobProvider } from "@react-pdf/renderer"
import axios from "axios"




const StyledCTA = styled.div`
    background: white;
    padding: 10px 20px;
    height: 45px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    color: #D95F6C;
    cursor: pointer;
    transition: box-shadow 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);

    &:hover{
        box-shadow: none !important;
    }
`;
const StyledCardContainer = styled.div`
   display: flex;
   flex-wrap: wrap;
`;
const StyledLink = styled(Link)`
    background: white;
    padding: 10px 20px;
    height: 45px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    color: #D95F6C;
    cursor: pointer;
    transition: box-shadow 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);

    &:hover{
        box-shadow: none !important;
    }
`;
function ChildGamesSecondary(props) {
    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user.user)
    const history = useHistory();
    const { levelno } = props.match.params;
    const { id } = props.match.params;
    const [gameResults, setGameResults] = useState([]);
    const [shareVisible, setShareVisible] = useState(false);
    const [correct, setCorrect] = useState(0);
    const [childDetails, setChildDetails] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false);

    const countCorrectlyAnswered = (res) => {
        let correctAnswered = 0;
        res.map(game => {
            if (game.played) {
                correctAnswered += game.data.score;
            }
        })
        return correctAnswered;
    }

    useEffect(() => {
        axios.get(`${api}/cp/pupil/${id}`, {}, {
        }).then(res => {
            const result = res.data.pupil_id[0];
            setChildDetails(result);


            if (!result) {
                setLoading(false);
            } else if (result.pt_email == user.email) {
                axios.get(`${api}/cp/pupil_levels_by_levels/${id}/${levelno}`, {}, {
                }).then(res => {

                    const result = res.data.data;

                    setGameResults(result);
                    setCorrect(countCorrectlyAnswered(result));
                    setLoading(false);
                }).catch(error => {
                    setLoading(false);
                });

            } else {
                setError(true)
                setLoading(false);
            }

        }).catch(error => {
        });

    }, [])
    if (loading) {
        return <div>
            <BackButton to="/dashboard" />
            <h5 className="text-center color-text-green">Loading...</h5>
        </div>
    }
    else if (typeof (childDetails) == "undefined" || error) {
        return <div>
            <BackButton to="/dashboard" />
            <h5 className="text-center color-text-green">Child Not Found</h5>
        </div>

    } else {
        return (
            <div>
                <ShareModal levelno={levelno} pupil={id} visible={shareVisible} onClose={() => setShareVisible(false)} />
                <Row>
                    <Col>
                        <BackButton onClick={() => history.goBack()} />

                        <h5 className="color-text-green mb-0 text-center">{childDetails.first_name + " " + childDetails.last_name}: Level {levelno}</h5>
                    </Col>
                </Row>
                <div className="w-100 bg-white mt-3 p-3" style={{ borderRadius: 10 }}>
                    <div className="d-flex flex-row align-items-center justify-content-center mb-4">
                        <img src={bronze_rosette} className="mx-2" width={40} style={{ opacity: correct >= 100 ? '1' : '0.3' }} />
                        <img src={grey_rosette} className="mx-2" width={40} style={{ opacity: correct >= 200 ? '1' : '0.3' }} />
                        <img src={gold_rosette} className="mx-2" width={40} style={{ opacity: correct >= 300 ? '1' : '0.3' }} />
                    </div>
                    <StyledCardContainer>
                        {gameResults.map((result, i) => {
                            if (result.played)
                                return <GameCard key={i} levelno={levelno} date={result.end_date_time} gameNumber={result.game_no} score={result.data.score} />
                            else
                                return <GameCard key={i} gameNumber={result.game_no} score={result.data.score} noresults />
                        })}
                        {[...Array(50 - gameResults.length)].map((result, i) => {

                            return <GameCard gameNumber="0" score="0" blocked />
                        })}

                    </StyledCardContainer>

                    <div className="d-flex justify-content-between mt-3" style={{ paddingLeft: 10, paddingRight: 10 }}>

                        <CustomButton onClick={() => history.push(`/dashboard/child/${childDetails.id}/certificates`)} bgColor={COLORS.green} color={COLORS.text_dark_green} hover={COLORS.text_green} style={{ padding: "0 30px", fontSize: 15 }}><img src={printer} style={{ width: 20, marginRight: 5 }} />
                            Print Certificate
                        </CustomButton>


                        {/* <CustomButton bgColor={COLORS.green} color={COLORS.text_dark_green} hover={COLORS.text_green} style={{ padding: "0 30px", fontSize: 15 }}><img src={printer} style={{ width: 20, marginRight: 5 }} />Print Certificate</CustomButton> */}
                        <CustomButton onClick={() => setShareVisible(true)} bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ padding: "0 30px", fontSize: 15 }}><img src={share} style={{ width: 20, marginRight: 5 }} />Share Progress</CustomButton>
                    </div>
                </div>
            </div >
        );
    }
}

export default ChildGamesSecondary;